module.exports = __webpack_public_path__ + "static/img/d2.19eb901.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/d2.png
// module id = aXmm
// module chunks = 0